module.exports = __webpack_public_path__ + "img/logo_black.ab81607b.png";